import { createApi } from '@reduxjs/toolkit/query/react';

import { customBaseQuery } from '../../common/api/api-helpers';

export const baseApi = createApi({
  baseQuery: customBaseQuery(),
  endpoints: () => ({}),
  tagTypes: [
    'NotificationSettings',
    'Notifications',
    'Notification',
    'LiveData',
    'Usage',
    'SunriseSunset',
    'Weather',
    'Invitations',
    'SiteUsers',
    'Retailers',
    'Tariffs',
    'Utilities',
    'SiteConsents',
    'DataExports',
  ],
});

export const {} = baseApi;
